module.exports = __webpack_public_path__ + "img/check-your-credit-score-hero-mobile.ad4647a4.jpg";